/* eslint-disable no-shadow */
import React, { PureComponent } from 'react'
import Select from 'react-select'
import PropTypes from 'prop-types'
import { isString } from 'lodash'

import { Wrapper, InnerWrapper } from './styles'

const formatOptionLabel = ({ label, customAbbreviation }) => {
  const getValueColor = customAbbreviation => {
    if (customAbbreviation >= 70) {
      return '#1CB954'
    }
    return '#999999'
  }

  return (
    <Wrapper>
      <div>{label}</div>
      {customAbbreviation && (
        <InnerWrapper color={getValueColor(customAbbreviation)}>
          {`${customAbbreviation}% Match`}
        </InnerWrapper>
      )}
    </Wrapper>
  )
}

class SelectField extends PureComponent {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string,
        label: PropTypes.string,
      })
    ),
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        value: PropTypes.string,
        label: PropTypes.string,
      }),
    ]).isRequired,
  }

  static defaultProps = {
    placeholder: '',
    options: [],
    label: '',
  }

  handleChange = selectedOption => {
    const { onChange } = this.props
    onChange(selectedOption)
  }

  render() {
    const {
      value,
      name,
      placeholder,
      customClassname,
      options,
      menuPlacement,
      required,
      defaultValue,
      customStyles,
      label,
    } = this.props

    return (
      <div className={customClassname}>
        <Select
          name={name}
          value={
            (value && !isString(value)) || !defaultValue
              ? value
              : options.find(({ value }) => value === defaultValue)
          }
          options={options}
          clearable={false}
          className="react-select"
          styles={customStyles}
          placeholder={placeholder}
          classNamePrefix="react-select"
          menuPlacement={menuPlacement}
          required={required}
          defaultValue={defaultValue}
          formatOptionLabel={formatOptionLabel}
          // menuIsOpen
          menuPortalTarget={document.body}
          label={label}
          customClassname={customClassname}
          onChange={this.handleChange}
        />
        <label htmlFor={label}>{label}</label>
        {required && (
          <>
            <input
              value={value}
              tabIndex={-1}
              label={label}
              autoComplete="off"
              style={{
                opacity: 0,
                width: '100%',
                height: 0,
                position: 'absolute',
                padding: 0,
              }}
              required={required}
              onChange={this.handleChange}
            />
          </>
        )}
      </div>
    )
  }
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const renderSelectField = props => {
  const {
    input,
    meta,
    options,
    placeholder,
    className,
    menuPlacement,
    required,
    customClassname,
    defaultValue,
    label,
  } = props

  return (
    <div className={`form__form-group-input-wrap ${className}`}>
      <SelectField
        {...input}
        defaultValue={defaultValue}
        menuPlacement={menuPlacement}
        options={options}
        placeholder={placeholder}
        required={required}
        label={label}
        customClassname={customClassname}
      />
      {meta.touched && meta.error && (
        <span
          className="form__form-group-error"
          data-cy="login-form__form-group-error-select"
        >
          {meta.error}
        </span>
      )}
    </div>
  )
}

renderSelectField.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func,
    name: PropTypes.string,
    label: PropTypes.string,
  }).isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    })
  ),
  placeholder: PropTypes.string,
  className: PropTypes.string,
}

renderSelectField.defaultProps = {
  meta: null,
  options: [],
  placeholder: '',
  className: '',
}

export default renderSelectField
